import dom from "../../../../dist/jsx-render/dom"
import { WidgetController } from "../WidgetController"
import { app } from "../../../Frame/App";
import { WidgetTypes } from "./WidgetTypes";
import { IWidgetComponent } from "../Components/IWidgetComponent";
import { WidgetSizer } from "../Modules/WidgetSizer";
import { IWidgetLayoutItem } from "../Server/IWidgetLayoutItem";

export enum SortType { desc, asc }

export class LayoutModel {
    widgetLayout: string;
    parentId: number;
}

export abstract class WidgetBase {
    public guid: string;
    public column: number;
    public row: number;
    public colSpan: number;
    public rowSpan: number;
    public component: IWidgetComponent;

    private editArea: HTMLElement;
    private sizer: WidgetSizer;

    constructor(protected controller: WidgetController, public minColSpan: number, public minRowSpan: number) {
        this.guid = app.createGuid();
        this.colSpan = this.minColSpan;
        this.rowSpan = this.minRowSpan;
    }

    abstract loadProps(jsonProps: string): void;
    abstract saveProps(): string;
    abstract getType(): WidgetTypes;
    abstract showPopup(): void;
    abstract createComponent(column: number, row: number, colSpan?: number, rowSpan?: number, paramter?: number): HTMLElement;

    public load(item: IWidgetLayoutItem): void {
        this.column = item.column;
        this.row = item.row;
        this.colSpan = item.colSpan;
        this.rowSpan = item.rowSpan;
        this.loadProps(item.jsonProps);
    }

    public save(): IWidgetLayoutItem {
        return {
            type: this.getType(),
            column: this.column,
            row: this.row,
            colSpan: this.colSpan,
            rowSpan: this.rowSpan,
            jsonProps: this.saveProps()
        }
    }

    public isInside(column: number, row: number, colSpan: number, rowSpan: number): boolean {
        if (row + rowSpan <= this.row || row >= (this.row + this.rowSpan)) {
            return false;
        }
        if (column + colSpan <= this.column || column >= (this.column + this.colSpan)) {
            return false;
        }
        return true;
    }

    public setGridPosition(): void {
        this.component.element.style.gridColumnStart = this.column.toString();
        this.component.element.style.gridColumnEnd = (this.column + this.colSpan).toString();
        this.component.element.style.gridRowStart = this.row.toString();
        this.component.element.style.gridRowEnd = (this.row + this.rowSpan).toString();
    }

    public enableEdit(): void {
        this.sizer = new WidgetSizer(this.controller, this, this.component.element);
        this.sizer.create();

        // edit area
        this.editArea = <div className="edit-area"></div>;
        this.component.element.appendChild(this.editArea);

        // drag button
        let dragButton: HTMLElement = <span class="fa-stack drag-button" style="vertical-align: top;" draggable="true"><i class="fas fa-circle fa-stack-2x i-outer"></i><i class="far fa-arrows-alt fa-stack-1x i-inner"></i></span>;
        this.editArea.appendChild(dragButton);
        dragButton.addEventListener("dragstart", (ev: DragEvent) => {
            this.controller.dragdrop.startDragOnExistingWidget(ev, this.component.element, this);
        });

        dragButton.addEventListener("dragend", (ev: DragEvent) => {
            this.component.element.classList.remove("d-none");
        });

        // edit button
        let editButton: HTMLElement = <span class="fa-stack edit-button" style="vertical-align: top;"><i class="fas fa-circle fa-stack-2x i-outer"></i><i class="far fa-edit fa-stack-1x i-inner"></i></span>;
        this.editArea.appendChild(editButton);
        editButton.addEventListener("click", (ev: DragEvent) => {
            this.showPopup();
        });

        // delete button
        let deleteButton: HTMLElement = <span class="fa-stack delete-button" style="vertical-align: top;"><i class="fas fa-circle fa-stack-2x i-outer"></i><i class="far fa-trash fa-stack-1x i-inner"></i></span>;
        this.editArea.appendChild(deleteButton);
        deleteButton.addEventListener("click", (ev: DragEvent) => {
            this.controller.deleteWidget(this);
        });
    }

    public disableEdit(): void {
        this.editArea.parentElement.removeChild(this.editArea);
        this.editArea = null;
        if (this.sizer) {
            this.sizer.dispose();
            this.sizer = null;
        }
    }

    public recreate(): void {
        const inEdit = !app.isNullOrUndefined(this.editArea);
        let parent = this.component.element.parentElement;
        parent.removeChild(this.component.element);
        parent.appendChild(this.createComponent(this.column, this.row, this.colSpan, this.rowSpan));
        if (inEdit) {
            this.enableEdit();
        }
    }
}